$.fn.Quiz = function(index) {
  let self = this
  self.positive = self.find('.quiz__positive')
  self.negative = self.find('.quiz__negative')
  self.questions = self.find('.quiz__questions')

  self.find('.quiz__submit button').click(function() {
    self.find('.quiz__questions__item').removeClass('--error')
    self.find('.quiz__questions__incomplete').fadeOut('slow');

    var complete = true;
    self.find('.quiz__questions__item__inputs').each(function(index){
      if ($(this).find('input[name="yesno_' + index + '"]:checked').length == 0) {
        $(this).closest('.quiz__questions__item').addClass('--error')
        complete = false;
      }
    })
    if (complete) {
      var approved = true
      self.find('.quiz__questions__item input[value=no]').each(function(){
        if ($(this).is(':checked')) {
          approved = false
        }
      })
      if (approved) {
        //approved
        self.questions.fadeOut('slow', function() {
          self.positive.fadeIn('slow');
        });
      } else {
        //rejected
        self.questions.fadeOut('slow', function() {
          self.negative.fadeIn('slow');
        });
      }
    } else {
      //incomplete
      self.find('.quiz__questions__incomplete').fadeIn('slow');
      if (self.closest('.accordion__panel-content').length) {
        self.closest('.js-accordion__panel').css('max-height', self.closest('.accordion__panel-content').outerHeight() + 'px')
      }
    }
  })


  return function() {
    return self
  }()
}
